import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {LoaderService} from './loader.service';
import {Overlay} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {LoaderSpinComponent} from './components/loader-spin.component';

@Component({
    selector: 'app-loader',
    template: '',
})
export class LoaderComponent implements OnInit, OnDestroy {
    isLoading$: Subject<boolean> = this.loaderService.isLoading;
    overlayRef = null;
    subscription: Subscription = new Subscription();

    constructor(
        private loaderService: LoaderService,
        private overlay: Overlay,
    ) {
    }

    ngOnInit() {
        this.subscription.add(
            this.isLoading$.subscribe(
                (value) => {
                    if (value) {
                        this.showOverlay();
                    } else {
                        this.hideOverlay();
                    }
                }
            )
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    hideOverlay() {
        this.overlayRef.detach();
        this.overlayRef = null;
    }

    showOverlay() {
        if (this.overlayRef === null) {
            this.overlayRef = this.overlay.create({
                positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
                hasBackdrop: true,
            });
            this.overlayRef.attach(new ComponentPortal(LoaderSpinComponent));
        }
    }
}
